var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Paper, Skeleton, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { debounce } from 'lodash';
import { Fragment, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { TABLE_HIERARCHY_COLORS } from '../../../../enum';
import { formatNumberByLocale } from '../../../../util/locale';
import { calcTotalShrinkage, daysFromHours, hoursFromDays, hoursPerMonthFromHoursPerYear, hoursPerWeekFromHoursPerYear, percentFromHours, round2 } from '../../../../util/shrinkageCalculations';
import { NumberInput } from '../../../common';
import { TABLE_HIERARCHY_INDENTS } from '../../../common/tableHierarchy';
import { getWizardTableSx } from '../../common/WizardTable';
import { waitForApiSliceTerminal } from '../../common/waitForApiSliceTerminal';
import { OrgConfigWizardContext } from '../../context';
import { orgConfigShrinkageSaveApiKey, useSaveShrinkageAPI, useShrinkageConfigAPI } from '../../selectors';
import { PlannedBadge, TOTAL_DAYS_LIMIT, TOTAL_HOURS_LIMIT, TOTAL_PCT_LIMIT, UnplannedBadge } from '../../shrinkage/AddShrinkageModal';
import { configToRows, expandMergedToModalRows, getFactorName } from '../../shrinkage/ShrinkageStep';
import { SHRINKAGE_CATEGORY_IN_OFFICE, SHRINKAGE_CATEGORY_OUT_OF_OFFICE, SHRINKAGE_FACTOR_I18N_KEYS } from '../../shrinkage/shrinkageConstants';
var wizardFixedTableSx = function (theme) {
  return __assign(__assign({}, getWizardTableSx(theme)), {
    tableLayout: 'fixed',
    width: '100%',
    '& td:first-of-type, & th:first-of-type': {
      borderLeft: 1,
      borderLeftColor: 'grey.600'
    },
    '& td:last-child, & th:last-child': {
      borderRight: 1,
      borderRightColor: 'grey.600'
    },
    '& tr:first-of-type th, & tr:first-of-type td': {
      borderTop: 1,
      borderTopColor: 'grey.600'
    },
    '& tbody tr:last-of-type td': {
      borderBottom: 1,
      borderBottomColor: 'grey.600'
    },
    '& td:not(:first-of-type), & th:not(:first-of-type)': {
      textAlign: 'center'
    },
    '& td:not(:first-of-type) input': {
      textAlign: 'center'
    }
  });
};
var hasStaffSettingsForShrinkage = function (config) {
  return config.paidHoursPerDay > 0 && config.workingDaysPerYear > 0;
};
var normalizeRowsForStaffSettings = function (rows, config) {
  if (hasStaffSettingsForShrinkage(config)) return rows;
  return rows.map(function (row) {
    return __assign(__assign({}, row), {
      daysPerYear: 0,
      hoursPerYear: 0
    });
  });
};
var toNumberOrZero = function (value) {
  var n = Number.parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};
var applyStaffSettingsFormToConfig = function (config, staffSettingsForm) {
  if (!staffSettingsForm) return config;
  var paidHoursPerDay = toNumberOrZero(staffSettingsForm.agent.paidHoursPerDay);
  var workingDaysPerYear = Math.floor(toNumberOrZero(staffSettingsForm.agent.workingDaysPerYear));
  return __assign(__assign({}, config), {
    paidHoursPerDay: paidHoursPerDay,
    workingDaysPerYear: workingDaysPerYear,
    paidHoursPerYear: paidHoursPerDay * workingDaysPerYear
  });
};
var recalculateRowsForStaffSettings = function (rows, config) {
  if (!hasStaffSettingsForShrinkage(config)) return normalizeRowsForStaffSettings(rows, config);
  return rows.map(function (row) {
    var pct = row.percentShrinkage;
    if (pct == null) return row;
    var hours = round2(pct / 100 * config.paidHoursPerYear);
    return __assign(__assign({}, row), {
      hoursPerYear: hours,
      daysPerYear: round2(daysFromHours(hours, config.paidHoursPerDay))
    });
  });
};
var rowsEqual = function (a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
};
var mapConfigToForm = function (config) {
  return {
    config: config,
    rows: normalizeRowsForStaffSettings(expandMergedToModalRows(configToRows(config)), config),
    isDirty: false
  };
};
var trimSubcategory = function (value) {
  var s = value === null || value === void 0 ? void 0 : value.trim();
  return s || null;
};
var buildFactorGroups = function (sectionRows) {
  var order = [];
  var map = new Map();
  for (var _i = 0, sectionRows_1 = sectionRows; _i < sectionRows_1.length; _i++) {
    var row = sectionRows_1[_i];
    var name_1 = getFactorName(row);
    var group = map.get(name_1);
    if (!group) {
      group = [];
      map.set(name_1, group);
      order.push(name_1);
    }
    group.push(row);
  }
  return order.map(function (factorName) {
    var _a;
    return {
      factorName: factorName,
      rows: (_a = map.get(factorName)) !== null && _a !== void 0 ? _a : []
    };
  });
};
export var ReviewShrinkageSection = function (_a) {
  var _b;
  var locationId = _a.locationId,
    registry = _a.registry,
    _c = _a.staffSettingsForm,
    staffSettingsForm = _c === void 0 ? null : _c;
  var tReview = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.reviewStep'
  }).t;
  var tShrinkage = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.shrinkageStep'
  }).t;
  var tAddShrinkage = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.addShrinkageModal'
  }).t;
  var store = useStore();
  var _d = useContext(OrgConfigWizardContext).isReadOnly,
    isReadOnly = _d === void 0 ? false : _d;
  var plannedLabel = tAddShrinkage('plannedBadge');
  var unplannedLabel = tAddShrinkage('unplannedBadge');
  var _e = useShrinkageConfigAPI(locationId),
    configData = _e[0],
    fetchConfig = _e[1];
  var _f = useSaveShrinkageAPI(locationId),
    saveConfig = _f[1];
  var _g = useState({}),
    formMap = _g[0],
    setFormMap = _g[1];
  var formMapRef = useRef(formMap);
  useEffect(function () {
    formMapRef.current = formMap;
  }, [formMap]);
  var baselineRef = useRef({});
  var form = (_b = formMap[locationId]) !== null && _b !== void 0 ? _b : null;
  useEffect(function () {
    if (locationId) fetchConfig();
  }, [locationId, fetchConfig]);
  useEffect(function () {
    var data = configData.data;
    if (!data) return;
    setFormMap(function (prev) {
      var _a;
      var _b;
      if ((_b = prev[locationId]) === null || _b === void 0 ? void 0 : _b.isDirty) return prev;
      var mapped = mapConfigToForm(applyStaffSettingsFormToConfig(data, staffSettingsForm));
      baselineRef.current[locationId] = mapped.rows.map(function (r) {
        return __assign({}, r);
      });
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = mapped, _a));
    });
  }, [configData.data, locationId, staffSettingsForm]);
  useEffect(function () {
    if (!staffSettingsForm) return;
    setFormMap(function (prev) {
      var _a;
      var current = prev[locationId];
      if (!current) return prev;
      var nextConfig = applyStaffSettingsFormToConfig(current.config, staffSettingsForm);
      var nextRows = recalculateRowsForStaffSettings(current.rows, nextConfig);
      var configChanged = current.config.paidHoursPerDay !== nextConfig.paidHoursPerDay || current.config.workingDaysPerYear !== nextConfig.workingDaysPerYear || current.config.paidHoursPerYear !== nextConfig.paidHoursPerYear;
      var rowsChanged = !rowsEqual(current.rows, nextRows);
      if (!configChanged && !rowsChanged) return prev;
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = __assign(__assign({}, current), {
        config: nextConfig,
        rows: nextRows,
        isDirty: current.isDirty || rowsChanged
      }), _a));
    });
  }, [locationId, staffSettingsForm]);
  var transformDaysPerYear = useCallback(function (r, v, config) {
    var hours = v == null ? null : round2(hoursFromDays(v, config.paidHoursPerDay));
    var pct = hours == null ? null : round2(percentFromHours(hours, config.paidHoursPerYear));
    return __assign(__assign({}, r), {
      daysPerYear: v,
      hoursPerYear: hours,
      percentShrinkage: pct
    });
  }, []);
  var transformHoursPerYear = useCallback(function (r, v, config) {
    var days = v == null ? null : round2(daysFromHours(v, config.paidHoursPerDay));
    var pct = v == null ? null : round2(percentFromHours(v, config.paidHoursPerYear));
    return __assign(__assign({}, r), {
      daysPerYear: days,
      hoursPerYear: v,
      percentShrinkage: pct
    });
  }, []);
  var transformPercentShrinkage = useCallback(function (r, v, config, hasStaffSettings) {
    var hours = null;
    var days = null;
    if (v != null) {
      hours = hasStaffSettings ? round2(v / 100 * config.paidHoursPerYear) : 0;
      days = hasStaffSettings ? round2(daysFromHours(hours, config.paidHoursPerDay)) : 0;
    }
    return __assign(__assign({}, r), {
      percentShrinkage: v,
      hoursPerYear: hours,
      daysPerYear: days
    });
  }, []);
  var transformRow = useCallback(function (r, field, v, config, hasStaffSettings) {
    if (!hasStaffSettings && field !== 'percentShrinkage') {
      return __assign(__assign({}, r), {
        daysPerYear: 0,
        hoursPerYear: 0
      });
    }
    if (field === 'daysPerYear') return transformDaysPerYear(r, v, config);
    if (field === 'hoursPerYear') return transformHoursPerYear(r, v, config);
    return transformPercentShrinkage(r, v, config, hasStaffSettings);
  }, [transformDaysPerYear, transformHoursPerYear, transformPercentShrinkage]);
  var handleRowChange = useCallback(function (rowIndex, field, value) {
    setFormMap(function (prev) {
      var _a;
      var current = prev[locationId];
      if (!current) return prev;
      var hasStaffSettings = hasStaffSettingsForShrinkage(current.config);
      var numVal = value == null || value === '' ? null : Number(value);
      var v = Number.isFinite(numVal) ? numVal : null;
      var rows = current.rows.map(function (r, i) {
        return i !== rowIndex ? r : transformRow(r, field, v, current.config, hasStaffSettings);
      });
      return __assign(__assign({}, prev), (_a = {}, _a[locationId] = __assign(__assign({}, current), {
        rows: rows,
        isDirty: true
      }), _a));
    });
  }, [locationId, transformRow]);
  var saveConfigRef = useRef(saveConfig);
  useEffect(function () {
    saveConfigRef.current = saveConfig;
  }, [saveConfig]);
  var doSave = useCallback(function (locId) {
    return __awaiter(void 0, void 0, void 0, function () {
      var f, rows, outOfOfficeRows, inOfficeRows, oosPercent, iosPercent, totalShrinkage, totalHours, totalDays, factors, payload, saveKey, ok;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            f = formMapRef.current[locId];
            if (!(f === null || f === void 0 ? void 0 : f.isDirty)) return [2 /*return*/, true];
            rows = f.rows;
            outOfOfficeRows = rows.filter(function (r) {
              return r.shrinkageCategory === SHRINKAGE_CATEGORY_OUT_OF_OFFICE;
            });
            inOfficeRows = rows.filter(function (r) {
              return r.shrinkageCategory === SHRINKAGE_CATEGORY_IN_OFFICE;
            });
            oosPercent = outOfOfficeRows.reduce(function (s, r) {
              var _a;
              return s + ((_a = r.percentShrinkage) !== null && _a !== void 0 ? _a : 0);
            }, 0);
            iosPercent = inOfficeRows.reduce(function (s, r) {
              var _a;
              return s + ((_a = r.percentShrinkage) !== null && _a !== void 0 ? _a : 0);
            }, 0);
            totalShrinkage = calcTotalShrinkage(oosPercent, iosPercent);
            totalHours = totalShrinkage / 100 * f.config.paidHoursPerYear;
            totalDays = totalShrinkage / 100 * f.config.workingDaysPerYear;
            if (rows.some(function (r) {
              var _a;
              return ((_a = r.percentShrinkage) !== null && _a !== void 0 ? _a : 0) > 100;
            }) || totalDays > TOTAL_DAYS_LIMIT || totalHours > TOTAL_HOURS_LIMIT || totalShrinkage > TOTAL_PCT_LIMIT) {
              return [2 /*return*/, false];
            }
            factors = f.rows.map(function (r) {
              var _a, _b, _c;
              return {
                id: r.id,
                shrinkageCategory: r.shrinkageCategory,
                shrinkageFactor: getFactorName(r),
                shrinkageSubcategory: r.shrinkageSubcategory,
                shrinkageType: r.isPlanned ? 'planned' : 'unplanned',
                daysPerYear: (_a = r.daysPerYear) !== null && _a !== void 0 ? _a : null,
                hoursPerYear: (_b = r.hoursPerYear) !== null && _b !== void 0 ? _b : null,
                percentShrinkage: (_c = r.percentShrinkage) !== null && _c !== void 0 ? _c : null
              };
            });
            payload = {
              factors: factors
            };
            saveKey = orgConfigShrinkageSaveApiKey(locId);
            return [4 /*yield*/, waitForApiSliceTerminal(store, saveKey, function () {
              return saveConfigRef.current(payload);
            })];
          case 1:
            ok = _a.sent();
            if (ok) {
              baselineRef.current[locId] = f.rows.map(function (r) {
                return __assign({}, r);
              });
              setFormMap(function (prev) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[locId] = __assign(__assign({}, f), {
                  isDirty: false
                }), _a));
              });
            }
            return [2 /*return*/, ok];
        }
      });
    });
  }, [store]);
  var scheduleDebouncedSave = useMemo(function () {
    return debounce(function (locId) {
      void doSave(locId);
    }, 500);
  }, [doSave]);
  useEffect(function () {
    if (!(form === null || form === void 0 ? void 0 : form.isDirty)) return;
    scheduleDebouncedSave(locationId);
  }, [form === null || form === void 0 ? void 0 : form.isDirty, form === null || form === void 0 ? void 0 : form.rows, locationId, scheduleDebouncedSave]);
  useEffect(function () {
    registry.register('shrinkage', {
      flush: function () {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            scheduleDebouncedSave.cancel();
            return [2 /*return*/, doSave(locationId)];
          });
        });
      },
      cancelPending: function () {
        return scheduleDebouncedSave.cancel();
      },
      get isDirty() {
        var _a, _b;
        return (_b = (_a = formMapRef.current[locationId]) === null || _a === void 0 ? void 0 : _a.isDirty) !== null && _b !== void 0 ? _b : false;
      }
    });
    return function () {
      return registry.unregister('shrinkage');
    };
  }, [registry, locationId, scheduleDebouncedSave, doSave]);
  var pct = function (row) {
    var _a;
    return (_a = row.percentShrinkage) !== null && _a !== void 0 ? _a : 0;
  };
  var hrs = function (row) {
    var _a;
    return (_a = row.hoursPerYear) !== null && _a !== void 0 ? _a : 0;
  };
  var daysVal = function (row) {
    var _a;
    return (_a = row.daysPerYear) !== null && _a !== void 0 ? _a : 0;
  };
  var formatPct = function (n) {
    return "".concat(formatNumberByLocale(round2(n), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }), " %");
  };
  var formatNum = function (n) {
    return formatNumberByLocale(round2(n), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  var formatMth = function (h) {
    return formatNumberByLocale(round2(hoursPerMonthFromHoursPerYear(h)), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  var formatWk = function (h) {
    return formatNumberByLocale(round2(hoursPerWeekFromHoursPerYear(h)), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };
  var getFieldMax = useCallback(function (field) {
    if (!form) return 0;
    if (field === 'daysPerYear') return form.config.workingDaysPerYear;
    if (field === 'hoursPerYear') return form.config.paidHoursPerYear;
    return 100;
  }, [form]);
  var numericSx = {
    fontFeatureSettings: '"tnum"',
    fontVariantNumeric: 'tabular-nums'
  };
  var sectionHeaderSx = {
    bgcolor: 'text.primary',
    '& td': {
      color: 'common.white',
      fontWeight: 600
    }
  };
  var sectionTotalRowSx = {
    bgcolor: TABLE_HIERARCHY_COLORS.lightBlue
  };
  var factorRowSx = {
    bgcolor: TABLE_HIERARCHY_COLORS.lightBlueGray
  };
  var subcategoryRowSx = {
    bgcolor: TABLE_HIERARCHY_COLORS.lightGray
  };
  var totalRowSx = {
    bgcolor: 'text.primary',
    '& td': {
      color: 'common.white',
      fontWeight: 'bold'
    }
  };
  var aggregates = useMemo(function () {
    if (!form) return null;
    var rows = form.rows;
    var _a = form.config,
      paidHoursPerYear = _a.paidHoursPerYear,
      workingDaysPerYear = _a.workingDaysPerYear;
    var outOfOfficeRows = rows.filter(function (r) {
      return r.shrinkageCategory === SHRINKAGE_CATEGORY_OUT_OF_OFFICE;
    });
    var inOfficeRows = rows.filter(function (r) {
      return r.shrinkageCategory === SHRINKAGE_CATEGORY_IN_OFFICE;
    });
    var oosPercent = outOfOfficeRows.reduce(function (s, r) {
      return s + pct(r);
    }, 0);
    var iosPercent = inOfficeRows.reduce(function (s, r) {
      return s + pct(r);
    }, 0);
    var totalShrinkage = round2(calcTotalShrinkage(oosPercent, iosPercent));
    return {
      rows: rows,
      outOfOfficeRows: outOfOfficeRows,
      inOfficeRows: inOfficeRows,
      oosPercent: oosPercent,
      iosPercent: iosPercent,
      totalShrinkage: totalShrinkage,
      oosHours: outOfOfficeRows.reduce(function (s, r) {
        return s + hrs(r);
      }, 0),
      iosHours: inOfficeRows.reduce(function (s, r) {
        return s + hrs(r);
      }, 0),
      oosDays: outOfOfficeRows.reduce(function (s, r) {
        return s + daysVal(r);
      }, 0),
      iosDays: inOfficeRows.reduce(function (s, r) {
        return s + daysVal(r);
      }, 0),
      totalDays: round2(totalShrinkage / 100 * workingDaysPerYear),
      totalHours: round2(totalShrinkage / 100 * paidHoursPerYear),
      pctOverLimitRows: rows.filter(function (r) {
        return pct(r) > 100;
      })
    };
  }, [form]);
  if (!form || !aggregates) return _jsx(Skeleton, {
    variant: "rectangular",
    height: 200,
    sx: {
      borderRadius: 1
    }
  });
  if (form.rows.length === 0) {
    return _jsx(Typography, __assign({
      color: "text.secondary"
    }, {
      children: tReview('noData', {
        defaultValue: 'There is no data to display.'
      })
    }));
  }
  var rows = aggregates.rows,
    outOfOfficeRows = aggregates.outOfOfficeRows,
    inOfficeRows = aggregates.inOfficeRows,
    oosPercent = aggregates.oosPercent,
    iosPercent = aggregates.iosPercent,
    oosHours = aggregates.oosHours,
    iosHours = aggregates.iosHours,
    oosDays = aggregates.oosDays,
    iosDays = aggregates.iosDays,
    totalDays = aggregates.totalDays,
    totalHours = aggregates.totalHours,
    totalShrinkage = aggregates.totalShrinkage,
    pctOverLimitRows = aggregates.pctOverLimitRows;
  var totalDaysOverLimit = totalDays > TOTAL_DAYS_LIMIT;
  var totalHoursOverLimit = totalHours > TOTAL_HOURS_LIMIT;
  var totalPctOverLimit = totalShrinkage > TOTAL_PCT_LIMIT;
  var anyTotalOverLimit = totalDaysOverLimit || totalHoursOverLimit || totalPctOverLimit;
  var hasStaffSettings = hasStaffSettingsForShrinkage(form.config);
  var getRowGlobalIndex = function (row) {
    return rows.indexOf(row);
  };
  var renderDataRow = function (sectionLabel, row, label, rowSx, isSubcategory) {
    var _a, _b, _c;
    if (isSubcategory === void 0) {
      isSubcategory = false;
    }
    var globalIdx = getRowGlobalIndex(row);
    var resolvedLabel = isSubcategory ? label : tShrinkage("factors.".concat(SHRINKAGE_FACTOR_I18N_KEYS[label]), {
      defaultValue: label
    });
    var pctOverLimit = pct(row) > 100;
    return _jsxs(TableRow, __assign({
      sx: rowSx
    }, {
      children: [_jsx(TableCell, __assign({
        sx: __assign(__assign({}, rowSx), isSubcategory && {
          pl: TABLE_HIERARCHY_INDENTS[1]
        })
      }, {
        children: _jsxs(Stack, __assign({
          direction: "row",
          alignItems: "center",
          spacing: 0.75
        }, {
          children: [_jsx(Typography, __assign({
            component: "span",
            sx: {
              flex: 1,
              minWidth: 0
            }
          }, {
            children: resolvedLabel
          })), row.isPlanned ? _jsx(PlannedBadge, {
            ariaLabel: plannedLabel
          }) : _jsx(UnplannedBadge, {
            ariaLabel: unplannedLabel
          })]
        }))
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: __assign(__assign({}, numericSx), pctOverLimit && {
          color: 'error.main',
          fontWeight: 600
        })
      }, {
        children: _jsx(NumberInput, {
          fullWidth: true,
          size: "small",
          min: 0,
          decimal: 2,
          max: getFieldMax('daysPerYear'),
          disabled: isReadOnly || !hasStaffSettings,
          value: (_a = row.daysPerYear) !== null && _a !== void 0 ? _a : '',
          onChange: function (v) {
            return handleRowChange(globalIdx, 'daysPerYear', v);
          }
        })
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: numericSx
      }, {
        children: _jsx(NumberInput, {
          fullWidth: true,
          size: "small",
          min: 0,
          decimal: 2,
          max: getFieldMax('hoursPerYear'),
          disabled: isReadOnly || !hasStaffSettings,
          value: (_b = row.hoursPerYear) !== null && _b !== void 0 ? _b : '',
          onChange: function (v) {
            return handleRowChange(globalIdx, 'hoursPerYear', v);
          }
        })
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: numericSx
      }, {
        children: _jsx(NumberInput, {
          fullWidth: true,
          size: "small",
          min: 0,
          max: getFieldMax('percentShrinkage'),
          decimal: 2,
          disabled: isReadOnly,
          error: pctOverLimit,
          value: (_c = row.percentShrinkage) !== null && _c !== void 0 ? _c : '',
          onChange: function (v) {
            return handleRowChange(globalIdx, 'percentShrinkage', v);
          }
        })
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: numericSx
      }, {
        children: formatMth(hrs(row))
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: numericSx
      }, {
        children: formatWk(hrs(row))
      }))]
    }), "".concat(sectionLabel, "-").concat(globalIdx));
  };
  var renderFactorHeaderRow = function (sectionLabel, factorName, groupIdx, groupRows) {
    var days = groupRows.reduce(function (s, r) {
      return s + daysVal(r);
    }, 0);
    var hours = groupRows.reduce(function (s, r) {
      return s + hrs(r);
    }, 0);
    var percent = groupRows.reduce(function (s, r) {
      return s + pct(r);
    }, 0);
    var rollupSx = __assign(__assign({}, numericSx), factorRowSx);
    var resolvedFactorName = tShrinkage("factors.".concat(SHRINKAGE_FACTOR_I18N_KEYS[factorName]), {
      defaultValue: factorName
    });
    return _jsxs(TableRow, __assign({
      sx: factorRowSx
    }, {
      children: [_jsx(TableCell, __assign({
        sx: factorRowSx
      }, {
        children: _jsx(Typography, __assign({
          component: "span"
        }, {
          children: resolvedFactorName
        }))
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: rollupSx
      }, {
        children: formatNum(days)
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: rollupSx
      }, {
        children: formatNum(hours)
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: rollupSx
      }, {
        children: formatPct(percent)
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: rollupSx
      }, {
        children: formatMth(hours)
      })), _jsx(TableCell, __assign({
        align: "center",
        sx: rollupSx
      }, {
        children: formatWk(hours)
      }))]
    }), "".concat(sectionLabel, "-factor-").concat(groupIdx));
  };
  var renderFactorGroup = function (sectionLabel, group, groupIdx) {
    var hasSubcat = function (r) {
      return !!trimSubcategory(r.shrinkageSubcategory);
    };
    var rowsWithSubcategory = group.rows.filter(hasSubcat);
    var rowsWithoutSubcategory = group.rows.filter(function (r) {
      return !hasSubcat(r);
    });
    return _jsxs(Fragment, {
      children: [rowsWithoutSubcategory.map(function (row) {
        return renderDataRow(sectionLabel, row, getFactorName(row), factorRowSx);
      }), rowsWithSubcategory.length > 0 && _jsxs(_Fragment, {
        children: [renderFactorHeaderRow(sectionLabel, group.factorName, groupIdx, rowsWithSubcategory), rowsWithSubcategory.map(function (row) {
          var _a;
          return renderDataRow(sectionLabel, row, (_a = trimSubcategory(row.shrinkageSubcategory)) !== null && _a !== void 0 ? _a : group.factorName, subcategoryRowSx, true);
        })]
      })]
    }, "".concat(sectionLabel, "-factor-").concat(groupIdx));
  };
  var renderSection = function (sectionLabel, totalLabel, sectionRows, sectionDays, sectionHours, sectionPercent) {
    return _jsxs(Fragment, {
      children: [_jsxs(TableRow, __assign({
        sx: sectionHeaderSx
      }, {
        children: [_jsx(TableCell, {
          children: sectionLabel
        }), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: tReview('shrinkageDaysPerYear')
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: tReview('shrinkageHoursPerYear')
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: tReview('totalShrinkagePct')
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: tReview('totalHoursPerMonth')
        })), _jsx(TableCell, __assign({
          align: "center"
        }, {
          children: tReview('totalHoursPerWeek')
        }))]
      })), buildFactorGroups(sectionRows).map(function (group, groupIdx) {
        return renderFactorGroup(sectionLabel, group, groupIdx);
      }), _jsxs(TableRow, __assign({
        sx: sectionTotalRowSx
      }, {
        children: [_jsx(TableCell, __assign({
          sx: {
            fontWeight: 600
          }
        }, {
          children: totalLabel
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: numericSx
        }, {
          children: formatNum(sectionDays)
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: numericSx
        }, {
          children: formatNum(sectionHours)
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: __assign(__assign({}, numericSx), {
            fontWeight: 600
          })
        }, {
          children: formatPct(sectionPercent)
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: numericSx
        }, {
          children: formatMth(sectionHours)
        })), _jsx(TableCell, __assign({
          align: "center",
          sx: numericSx
        }, {
          children: formatWk(sectionHours)
        }))]
      }))]
    }, sectionLabel);
  };
  return _jsxs(Stack, __assign({
    spacing: 1.5
  }, {
    children: [pctOverLimitRows.length > 0 && _jsx(Typography, __assign({
      color: "error",
      variant: "body2"
    }, {
      children: tAddShrinkage('percentOverLimit', {
        defaultValue: 'Shrinkage % cannot exceed 100% for any individual factor. Please correct the highlighted values.'
      })
    })), anyTotalOverLimit && _jsx(Typography, __assign({
      color: "error",
      variant: "body2"
    }, {
      children: tAddShrinkage('totalOverLimit', {
        defaultValue: 'Total Shrinkage cannot exceed 365 days/year, 2920 hours/year, or 99.99%. Please correct the highlighted values.'
      })
    })), _jsx(TableContainer, __assign({
      component: Paper,
      elevation: 0
    }, {
      children: _jsx(Table, __assign({
        size: "small",
        sx: wizardFixedTableSx
      }, {
        children: _jsxs(TableBody, {
          children: [outOfOfficeRows.length > 0 && renderSection(tReview('outOfOffice'), tReview('totalOutOfOfficeShrinkage'), outOfOfficeRows, oosDays, oosHours, oosPercent), inOfficeRows.length > 0 && renderSection(tReview('inOffice'), tReview('totalInOfficeShrinkage'), inOfficeRows, iosDays, iosHours, iosPercent), _jsxs(TableRow, __assign({
            sx: totalRowSx
          }, {
            children: [_jsx(TableCell, {
              children: tReview('totalShrinkage')
            }), _jsx(TableCell, __assign({
              align: "center",
              sx: numericSx
            }, {
              children: formatNum(totalDays)
            })), _jsx(TableCell, __assign({
              align: "center",
              sx: numericSx
            }, {
              children: formatNum(totalHours)
            })), _jsx(TableCell, __assign({
              align: "center",
              sx: numericSx
            }, {
              children: formatPct(totalShrinkage)
            })), _jsx(TableCell, __assign({
              align: "center",
              sx: numericSx
            }, {
              children: formatMth(totalHours)
            })), _jsx(TableCell, __assign({
              align: "center",
              sx: numericSx
            }, {
              children: formatWk(totalHours)
            }))]
          }))]
        })
      }))
    }))]
  }));
};